var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-secondary',{staticClass:"pc-content",attrs:{"header":_vm.headerOptions}},[(_vm.mainImage)?_c('page-content-image',{attrs:{"contentImage":_vm.mainImage}}):_vm._e(),_c('page-container',[_c('page-list-container',{attrs:{"item-list":_vm.itemList,"main-image":_vm.mainImage,"description":_vm.description,"lastExpanded":_vm.lastExpanded}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }